<template>
    <div class="management-planning-form2">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <div class="lock-msg-top">
                <div class="msg">
                    {{
                        `Caso queira que suas informações ${
                            form.statusLock ? 'não sejam' : 'sejam'
                        } públicas, clique no botão abaixo.`
                    }}
                </div>

                <LockPP
                    :statusLock="Number(form.statusLock)"
                    :lockMsg="'Privado'"
                    :unlockMsg="'Público'"
                    @click="form.statusLock = Number(!form.statusLock)"
                    v-if="showLock"
                />
            </div>

            <b-form-group
                label="Equipe dedicada para comunicação?"
                label-for="hasTeam"
                class="required"
            >
                <b-form-radio-group
                    id="hasTeam"
                    name="hasTeam"
                    v-model="$v.form.hasTeam.selected.$model"
                    :options="form.hasTeam.options"
                    :state="validateState('hasTeam')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['equipeComunicacao'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['equipeComunicacao'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasTeam')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Missão" label-for="hasMission" class="required">
                <b-form-radio-group
                    id="hasMission"
                    name="hasMission"
                    v-model="$v.form.hasMission.selected.$model"
                    :options="form.hasMission.options"
                    :state="validateState('hasMission')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['missaoDefinida'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['missaoDefinida'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasMission')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Missão da iniciativa" label-for="aboutMission" v-if="form.hasMission.selected">
                <b-form-textarea
                    id="aboutMission"
                    name="aboutMission"
                    v-model="form.aboutMission"
                    placeholder="Descreva aqui."
                    rows="5"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['qualMissao'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['qualMissao'].value"
                />
            </b-form-group>

            <b-form-group label="A iniciativa tem uma visão definida?" label-for="hasVision" class="required">
                <b-form-radio-group
                    id="hasVision"
                    name="hasVision"
                    v-model="$v.form.hasVision.selected.$model"
                    :options="form.hasVision.options"
                    :state="validateState('hasVision')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['visaoDefinida'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['visaoDefinida'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasVision')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Qual é a visão?" label-for="aboutVision" v-if="form.hasVision.selected">
                <b-form-textarea
                    id="aboutVision"
                    name="aboutVision"
                    v-model="form.aboutVision"
                    placeholder="Descreva aqui."
                    rows="5"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['qualVissao'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['qualVissao'].value"
                />
            </b-form-group>

            <b-form-group label="Valores *" label-for="hasValues" class="required">
                <b-form-radio-group
                    id="hasValues"
                    name="hasValues"
                    v-model="$v.form.hasValues.selected.$model"
                    :options="form.hasValues.options"
                    :state="validateState('hasValues')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['valoresDefinidos'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['valoresDefinidos'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasValues')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group label="Valores da iniciativa" label-for="aboutValues" v-if="form.hasValues.selected">
                <b-form-textarea
                    id="aboutValues"
                    name="aboutValues"
                    v-model="form.aboutValues"
                    placeholder="Descreva aqui."
                    rows="5"
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform || (isPlatform && getAuthorizationData && getAuthorizationData['qualValores'].value)
                    "
                ></b-form-textarea>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['qualValores'].value"
                />
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <slot name="platform-bottom-buttons"></slot>

                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'ManagementPlanningForm1' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-else>
                    <b-button :variant="'secondary'" @click="changeRegisterForm('ManagementPlanningForm1')"
                        >Voltar</b-button
                    >

                    <b-button
                        :variant="'primary'"
                        @click="changeRegisterForm('FinancialSustainabilityForm1')"
                        v-if="abbleNextPage"
                    >
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <b-modal
            ref="warning-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
        >
            <div class="content">
                <WarningMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="$router.push({ name: 'LoginForm' })">{{
                    $CONTINUAR_PLATAFORMA
                }}</b-button>
                <b-button variant="secondary" @click="nextPage()">Continuar cadastro</b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LockPP from '@/ui/lock-pp/LockPP'
import WarningMsgModal from '@/ui/modal/warning-msg-modal/WarningMsgModal'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { ManagementPlanningApi } from '../../api/management-planning'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const managementPlanningApi = new ManagementPlanningApi()

export default {
    components: { LockPP, WarningMsgModal, DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        showLock: {
            type: Boolean,
            default: true
        },
        abbleNextPage: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isDisabled: null,
            progress: 60.94,
            message: null,
            isUpdate: false,
            authorizationData: null,
            management: false,
            form: {
                statusLock: 1,
                hasTeam: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                hasMission: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                aboutMission: null,
                hasVision: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                aboutVision: null,
                hasValues: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                },
                aboutValues: null
            }
        }
    },
    validations: {
        form: {
            hasTeam: {
                selected: { required }
            },
            hasMission: {
                selected: { required }
            },
            hasVision: {
                selected: { required }
            },
            hasValues: {
                selected: { required }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData

            this.form.statusLock = data.view_iniciativa === null ? 1 : data.view_iniciativa
            this.form.hasTeam.selected = data.equipeComunicacao
            this.form.hasMission.selected = data.missaoDefinida
            this.form.aboutMission = data.qualMissao
            this.form.hasVision.selected = data.visaoDefinida
            this.form.aboutVision = data.qualVissao
            this.form.hasValues.selected = data.valoresDefinidos
            this.form.aboutValues = data.qualValores

            this.filterData()
            this.fetchAuthorization()
        },
        fetch() {
            this.setIsLoading(true)

            axios
                .all([managementPlanningApi.listPlanGest()])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.management = data
                        this.form.statusLock = data.view_iniciativa === null ? 1 : data.view_iniciativa
                        this.form.hasTeam.selected = data.equipeComunicacao
                        this.form.hasMission.selected = data.missaoDefinida
                        this.form.aboutMission = data.qualMissao
                        this.form.hasVision.selected = data.visaoDefinida
                        this.form.aboutVision = data.qualVissao
                        this.form.hasValues.selected = data.valoresDefinidos
                        this.form.aboutValues = data.qualValores
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress
            const data = {
                ...this.management,
                view_iniciativa: this.form.statusLock,
                equipeComunicacao: this.form.hasTeam.selected,
                missaoDefinida: this.form.hasMission.selected,
                qualMissao: this.form.aboutMission,
                visaoDefinida: this.form.hasVision.selected,
                qualVissao: this.form.aboutVision,
                valoresDefinidos: this.form.hasValues.selected,
                qualValores: this.form.aboutValues,
                percentual: currentProgress
            }

            this.setIsLoading(true)
            const request = this.isUpdate
                ? managementPlanningApi.updatePlanGest(data)
                : managementPlanningApi.finishPlanGest(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)
                    this.message = response.data.message

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.showModal('warning-modal-ref')
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        nextPage() {
            this.hideModal('warning-modal-ref')
            this.$router.push({ name: 'FinancialSustainabilityForm1' })
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getManagementPlanning(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        filterData() {
            if (this.receiveData) {
                this.form.hasTeam.options = this.form.hasTeam.options.filter(
                    x => Number(this.form.hasTeam.selected) === x.value
                )

                this.form.hasMission.options = this.form.hasMission.options.filter(
                    x => Number(this.form.hasMission.selected) === x.value
                )

                this.form.hasVision.options = this.form.hasVision.options.filter(
                    x => Number(this.form.hasVision.selected) === x.value
                )

                this.form.hasValues.options = this.form.hasValues.options.filter(
                    x => Number(this.form.hasValues.selected) === x.value
                )
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getProgress() {
            return this.$store.state.progress
        },
        getAuthorizationData() {
            return this.authorizationData
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/register-management-planning-forms/ManagementPlanningForm2.vue